import { useCallback } from 'react'
import { ToTagPropsFn } from '../../../types'
import { UserTagUser } from '../types'
import { CIMSTagProps } from '../../../../CIMSTag/types'
import { useUserSelectLabel } from '../../../../CIMSSelect/common/UserSelect/hooks/useUserSelectLabel'
import { useUserDeleted } from '../../../../../hooks/useUserDeleted'
import { useUserSelectTooltip } from '../../../../CIMSSelect/common/UserSelect/hooks/useUserSelectTooltip'

/**
 * a callback to transform User into the tags prop of a CIMSTags component
 */
export function useUserTagProps(options?: Pick<CIMSTagProps, 'color'>) {
  const text = useUserSelectLabel()
  const deleted = useUserDeleted()
  const tooltip = useUserSelectTooltip()
  const callback = useCallback<ToTagPropsFn<UserTagUser>>(
    (user) => {
      const { color } = options ?? {}
      return {
        text: text(user),
        tooltip: !!user.displayName ? tooltip(user) : undefined,
        strikethrough: deleted(user),
        color,
      }
    },
    [options, deleted, text, tooltip]
  )

  return callback
}
